import { useState } from "react";
import { useIntl } from "react-intl";
import { toast } from "react-toastify";
import TooltipButton from "../../common/tooltipButton";
import EnterpriseService from "../../../services/EnterpriseService";
import {
  errorMessageId,
  errorText,
  TOO_MANY_ATTEMPTS,
} from "../../../helpers/ErrorMessage";

// Send test email: an English email to the signed-in user, with their
// details, through the saved SMTP settings or, with none saved, the
// application's default ones. It is sent at once, so the answer says whether
// it went and, when it did not, why (naming the organisation's own server).
// waitReason: why it cannot be sent yet (unsaved changes), shown as its tooltip.
// onDone: after each send, so the status can show the new last test.
const SmtpTestEmailButton = ({ canUpdate, waitReason = "", onDone }) => {
  const intl = useIntl();
  const [sending, setSending] = useState(false);

  const failure = (body) => {
    if (body?.response === TOO_MANY_ATTEMPTS) {
      return errorText(body, intl);
    }
    return intl.formatMessage(
      { id: errorMessageId(body, intl, "smtp_test_failed") },
      { server: body?.values?.server, port: body?.values?.port }
    );
  };

  const send = async () => {
    setSending(true);
    try {
      const result = (await EnterpriseService.selfEnterpriseSMTPTest())?.data
        ?.response;
      toast.success(
        intl.formatMessage(
          {
            id: result?.usesDefault
              ? "smtp_test_email_sent_default"
              : "smtp_test_email_sent",
          },
          { email: result?.sentTo }
        )
      );
    } catch (error) {
      toast.error(failure(error?.response?.data));
    } finally {
      setSending(false);
      if (onDone) onDone();
    }
  };

  return (
    <TooltipButton
      outlined
      icon="pi pi-send"
      onClick={send}
      size="small"
      label={intl.formatMessage({ id: "smtp_send_test_email" })}
      type="button"
      disabled={!canUpdate || Boolean(waitReason) || sending}
      loading={sending}
      tooltipOptions={{ showOnDisabled: true, position: "bottom" }}
      tooltip={canUpdate ? waitReason : intl.formatMessage({ id: "no_permission" })}
    />
  );
};

export default SmtpTestEmailButton;
